import { Button, Input, Alert } from '@bdo/kitchensink';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiRoutes, buildApiRoute } from '../../config/apiRoutes';
import { appRoutes, buildAppRoute } from '../../config/appRoutes';
import { useLogging } from '../../hooks/useLogging';
import { useCaptureApi } from '../../hooks/useCaptureApi';
import Table from './Table';
import _ from 'lodash';

export default function List() {

    const { apiGet } = useCaptureApi();
    const [records, setRecords] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const logging = useLogging();
    const navigate = useNavigate(); 
    const { state } = useLocation();   
    const [pagination, setPagination] = useState(state?.capturesPagination || { 
        current:  1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        sort: null,
        search: ''
    }); 
    const skipFetchRef = React.useRef(false);
       
    useEffect(() => {   
        if ((pagination.search.length === 0 || pagination.search.length >= 3) && skipFetchRef.current === false) {   
         fetchData();
        }
        skipFetchRef.current = false;
    }, [pagination.current, pagination.pageSize, pagination.search, pagination.sort]);

    async function fetchData() {
        try {
            var queryParameters = {
                page: pagination.current,
                size: pagination.pageSize,
                search: pagination.search,
                sortOrder: pagination.sort === 'ascend' ? 'asc' : 'desc',
            }            
            setIsLoading(true);
            setHasError(false);
            const result = await apiGet(buildApiRoute(apiRoutes.captures.list), queryParameters);
            
            if (result && result.status === 200) {
                setRecords(result.data.records);
                setPagination((prev) => ({      
                    ...prev,
                    total: result.data.totalRecords
                }));
            }
            else {
                setHasError(true);
                logging.error("Failed to fetch captures, non success status code", { result: result });
            }                             
        }
        catch (ex) {
            setHasError(true);
            logging.error("Failed to fetch captures, non success status code", { exception: ex });
        }

        setIsLoading(false);
    }

    function handleTableChange(newpagination, sorter) {  
        const ispaginationChanged = pagination.current !== newpagination.current || pagination.pageSize !== newpagination.pageSize;
        
        if(!ispaginationChanged && sorter.order === undefined){
            skipFetchRef.current = true;
        }

        setPagination((prev) => ({      
            ...prev,
            current: newpagination.current,
            pageSize: newpagination.pageSize,
            sort: sorter.order
        }));
    }

    const handleSearchChange = _.debounce((value) => {  
        var currentpage= pagination.current  
        if (value.length === 0 || value.length >= 3) {                 
           currentpage = 1;
        }
        setPagination((prev) => ({
            ...prev,
            current: currentpage,
            search: value
        }));   
        }, 500);

    return (
        <>
            <header>
                <h1>My Captures</h1>
                {hasError && <Alert type="error" message="There was an issue fetching records, please try refreshing the page."  className="mb-3"/>}                
                <div className='controls'>
                    <Input
                        className='margin-tb'
                        type='text'
                        placeholder='Search existing'
                        defaultValue={pagination?.search || ''}
                        onChange={(e) => handleSearchChange(e.target.value)}
                    />
                    <Button
                        type='primary'
                        onClick={() => navigate(buildAppRoute(appRoutes.capture.create))}>
                        New
                    </Button>
                </div>
            </header>
            <Table
               isLoading={isLoading}
               records={records}               
               pagination={pagination}
               onTableChange={(pagination, filters, sorter) => handleTableChange(pagination, sorter)}
            />
        </>
    );
}